import { render, staticRenderFns } from "./PhotosElmwood.vue?vue&type=template&id=7927243d"
import script from "./PhotosElmwood.vue?vue&type=script&lang=js"
export * from "./PhotosElmwood.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports